import branchDebtRoutes from './branchDebtRoutes';
import storesRoutes from './storesRoutes';
import subscriptionsRoutes from './subscriptionsRoutes';
import catalogRoutes from './catalogRoutes';
import productsRoutes from './productsRoutes';
import supplierManagementRoutes from './supplierManagementRoutes';
import redemptionsRoutes from './redemptionsRoutes';
import generalSettingsRoutes from './../general/settings';
import campaignsRoutes from './campaignsRoutes';
import multipleCouponsRoutes from './multipleCouponsRoutes';
import customerRoutes from './customerRoutes.js';

export default [
  {
    path: '',
    name: 'LoyaltyHome',
    meta: {
      permissionPath: 'homepage.read',
    },
    component: () => import(/* webpackChunkName: "loyaltyHome" */ '@/views/loyaltyPanel/Home.vue'),
  },

  {
    path: 'branch-debt',
    name: 'BranchDebt',
    meta: {
      permissionPath: 'stores.debts.read',
    },
    component: () =>
      import(/* webpackChunkName: "branchDebt" */ '@/views/loyaltyPanel/branchDebt/BranchDebt.vue'),
    children: branchDebtRoutes,
  },

  {
    path: 'stores',
    name: 'CompanyStores',
    meta: {
      permissionPath: 'stores.read',
    },
    component: () =>
      import(/* webpackChunkName: "stores" */ '@/views/loyaltyPanel/stores/Stores.vue'),
    children: storesRoutes,
  },

  {
    path: 'subscriptions',
    name: 'Subscriptions',
    meta: {
      permissionPath: 'subscriptions.read',
    },
    component: () =>
      import(
        /* webpackChunkName: "subscriptions" */ '@/views/loyaltyPanel/subscriptions/Subscriptions.vue'
      ),
    children: subscriptionsRoutes,
  },

  {
    path: 'catalog',
    name: 'Catalog',
    meta: {
      permissionPath: 'gifts.read',
    },
    component: () =>
      import(/* webpackChunkName: "Catalog" */ '@/views/loyaltyPanel/catalog/Catalog.vue'),
    children: catalogRoutes,
  },
  {
    path: 'collaborators',
    name: 'Collaborators',
    component: () =>
      import(/* webpackChunkName: "collaborators" */ '@/views/loyaltyPanel/Collaborators.vue'),
  },

  {
    path: 'products',
    name: 'LoyaltyProducts',
    meta: {
      permissionPath: 'products.read',
    },
    component: () =>
      import(/* webpackChunkName: "products" */ '@/views/loyaltyPanel/products/Products.vue'),
    children: productsRoutes,
  },

  {
    path: 'customers',
    name: 'Customers',
    meta: {
      permissionPath: 'customers.read',
    },
    component: () =>
      import(/* webpackChunkName: "customers" */ '@/views/loyaltyPanel/customers/Customers.vue'),
    children: customerRoutes,
  },

  {
    path: 'user-rights',
    name: 'UserRights',
    meta: {
      permissionPath: 'users.read',
    },
    component: () =>
      import(/* webpackChunkName: "userRights" */ '@/views/loyaltyPanel/UserRights.vue'),
  },

  {
    path: 'business-profile',
    name: 'BusinessProfile',
    meta: {
      permissionPath: 'profile.read',
    },
    component: () =>
      import(/* webpackChunkName: "businessProfile" */ '@/views/loyaltyPanel/BusinessProfile.vue'),
  },

  {
    path: 'business-statistics',
    name: 'BusinessStatistics',
    meta: {
      permissionPath: 'statistics.read',
    },
    component: () =>
      import(
        /* webpackChunkName: "businessStatistics" */ '@/views/loyaltyPanel/BusinessStatistics.vue'
      ),
  },

  {
    path: 'point-titles',
    name: 'Point Titles',
    meta: {
      permissionPath: 'point_packages.read',
    },
    component: () =>
      import(/* webpackChunkName: "multipleCoupons" */ '@/views/loyaltyPanel/PointTitles.vue'),
  },

  {
    path: 'loyalty-cards',
    name: 'Loyalty Cards',
    meta: {
      permissionPath: 'loyalty_cards.read',
    },
    component: () =>
      import(/* webpackChunkName: "multipleCoupons" */ '@/views/loyaltyPanel/LoyaltyCards.vue'),
  },

  {
    path: 'redemptions',
    name: 'Redemptions',

    component: () =>
      import(
        /* webpackChunkName: "redemptions" */ '@/views/loyaltyPanel/redemptions/Redemptions.vue'
      ),
    children: redemptionsRoutes,
  },

  {
    path: 'supplier-management',
    name: 'Suppliers',
    meta: {
      permissionPath: 'suppliers.read',
    },
    component: () =>
      import(
        /* webpackChunkName: "supplierManagement" */ '@/views/loyaltyPanel/supplierManagement/SupplierManagement.vue'
      ),
    children: supplierManagementRoutes,
  },

  // {
  //     path: "sampling",
  //     name: "Sampling",
  //     component: () =>
  //         import(
  //             /* webpackChunkName: "1+1sampling" */ "@/views/loyaltyPanel/Sampling.vue"
  //         )
  // },

  // {
  //     path: "receipt-scanning",
  //     name: "Receipt Scanning",
  //     component: () =>
  //         import(
  //             /* webpackChunkName: "receiptScanning" */ "@/views/loyaltyPanel/ReceiptScanning.vue"
  //         )
  // },

  // {
  //     path: "check-in",
  //     name: "Check In",
  //     component: () =>
  //         import(
  //             /* webpackChunkName: "checkin" */ "@/views/loyaltyPanel/CheckIn.vue"
  //         )
  // },

  // {
  //     path: "serial-shopping",
  //     name: "Serial Shopping",
  //     component: () =>
  //         import(
  //             /* webpackChunkName: "serialShopping" */ "@/views/loyaltyPanel/SerialShopping.vue"
  //         )
  // },

  // {
  //     path: "contest-survey",
  //     name: "Contest & Survey",
  //     component: () =>
  //         import(
  //             /* webpackChunkName: "contestSurvey" */ "@/views/loyaltyPanel/ContestSurvey.vue"
  //         )
  // },

  // {
  //     path: "add-contest",
  //     name: "Add Contest",
  //     component: () =>
  //         import(
  //             /* webpackChunkName: "addContest" */ "@/views/loyaltyPanel/AddContest.vue"
  //         )
  // },

  // {
  //     path: "view-contest",
  //     name: "View Contest",
  //     component: () =>
  //         import(
  //             /* webpackChunkName: "viewContest" */ "@/views/loyaltyPanel/ViewContest.vue"
  //         )
  // },

  // {
  //     path: "view-participants",
  //     name: "View Participants",
  //     component: () =>
  //         import(
  //             /* webpackChunkName: "viewParticipants" */ "@/views/loyaltyPanel/ViewParticipants.vue"
  //         )
  // },

  // {
  //     path: "view-participant-answer",
  //     name: "View Participant Answer",
  //     component: () =>
  //         import(
  //             /* webpackChunkName: "viewParticipantAnswer" */ "@/views/loyaltyPanel/ViewParticipantAnswer.vue"
  //         )
  // },

  // {
  //     path: "roadcodes",
  //     name: "Roadcodes",
  //     component: () =>
  //         import(
  //             /* webpackChunkName: "roadcodes" */ "@/views/loyaltyPanel/Roadcodes.vue"
  //         )
  // },
  {
    path: 'loyalty-programs',
    name: 'LoyaltyPrograms',
    meta: {
      permissionPath: 'loyalty.read',
    },
    component: () =>
      import(/* webpackChunkName: "LoyaltyPrograms" */ '@/views/loyaltyPanel/LoyaltyPrograms.vue'),
  },

  {
    path: 'multiple-coupons/view-coupon/:coupon_id/claims',
    name: 'MultipleCouponsClaims',
    meta: {
      permissionPath: 'coupons.multiple.read',
    },
    component: () =>
      import(
        /* webpackChunkName: "viewCouponClaims" */ '@/views/loyaltyPanel/multipleCoupons/ViewCouponClaims'
      ),
  },

  {
    path: 'multiple-coupons',
    name: 'MultipleCoupons',
    meta: {
      permissionPath: 'coupons.multiple.read',
    },
    component: () =>
      import(
        /* webpackChunkName: "multipleCoupons" */ '@/views/loyaltyPanel/multipleCoupons/MultipleCoupons'
      ),
    children: multipleCouponsRoutes,
  },

  {
    path: 'campaigns',
    name: 'Campaigns',
    meta: {
      permissionPath: 'campaigns.read',
    },
    component: () =>
      import(
        /* webpackChunkName: "viewCampaigns" */ '@/views/loyaltyPanel/campaigns/Campaigns.vue'
      ),
    children: campaignsRoutes,
  },
  // {
  //     path: "view-campaigns",
  //     name: "Campaigns",
  //     component: () =>
  //         import(
  //             /* webpackChunkName: "viewCampaigns" */ "@/views/loyaltyPanel/campaigns/ViewCampaigns.vue"
  //         ),
  // },
  // {
  //     path: "view-campaign/:campaign_id/report",
  //     name: "CampaignReport",
  //     component: () =>
  //         import(
  //             /* webpackChunkName: "viewCampaigns" */ "@/views/loyaltyPanel/campaigns/ViewCampaignReport.vue"
  //         ),
  // },

  // {
  //     path: "new-campaign",
  //     name: "New Campaign",
  //     component: () =>
  //         import(
  //             /* webpackChunkName: "newCampaign" */ "@/views/loyaltyPanel/campaigns/NewCampaign.vue"
  //         )
  // },
  {
    path: 'reward',
    name: 'Reward',
    meta: {
      permissionPath: 'rewards.read',
    },
    component: () => import(/* webpackChunkName: "reward" */ '@/views/loyaltyPanel/Reward.vue'),
  },
  {
    path: 'store-coupons',
    name: 'Store Coupons',
    component: () =>
      import(/* webpackChunkName: "storeCoupons" */ '@/views/loyaltyPanel/StoreCoupons.vue'),
  },

  {
    path: 'general-settings',
    name: 'LoyaltyGeneralSettings',
    component: () => import(/* webpackChunkName: "subscriptions" */ '@/views/general/settings'),
    children: generalSettingsRoutes,
  },
];
